module.exports = __webpack_public_path__ + "8c18ea2c2da308f50647d7875398f78b.png";